import React from 'react';
import { Card, Grid, Box, Typography, Chip } from '@mui/material';
import { motion } from 'framer-motion';
import BusinessIcon from '@mui/icons-material/Business';
import { useScrollAnimation, fadeInLeft } from '../hooks/useScrollAnimation';

const ExperienceCard = ({ exp, idx }) => {
  const [expRef, expControls] = useScrollAnimation();

  return (
    <Card
      component={motion.div}
      ref={expRef}
      initial="hidden"
      animate={expControls}
      variants={fadeInLeft}
      whileHover={{ x: 8, transition: { duration: 0.3 } }}
      sx={{
        mb: 4,
        background: 'var(--card-bg)',
        backdropFilter: 'blur(10px)',
        border: '1px solid var(--border-subtle)',
        p: { xs: 3, md: 5 },
        transition: 'all 0.3s ease',
        '&:hover': {
          borderColor: 'primary.main',
          transform: 'translateY(-4px)',
          boxShadow: '0 16px 48px rgba(0, 245, 255, 0.15)',
        },
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: 2,
              background: 'linear-gradient(135deg, #00F5FF, #FF6B35)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <BusinessIcon sx={{ fontSize: 32, color: '#0B0D17' }} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            {exp.company}
          </Typography>
          <Typography variant="body2" sx={{ color: 'primary.main', mb: 1, fontWeight: 600 }}>
            {exp.role}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {exp.period}
          </Typography>
        </Grid>

        <Grid item xs={12} md={9}>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              mb: 3,
              lineHeight: 1.8,
            }}
          >
            {exp.description}
          </Typography>

          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Key Achievements:
          </Typography>
          <Box component="ul" sx={{ mb: 3, pl: 2 }}>
            {exp.achievements.map((achievement, achIdx) => (
              <Typography
                component="li"
                key={achIdx}
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  mb: 1,
                  lineHeight: 1.6,
                }}
              >
                {achievement}
              </Typography>
            ))}
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {exp.technologies.map((tech, techIdx) => (
              <Chip
                key={techIdx}
                label={tech}
                size="small"
                sx={{
                  background: 'rgba(0, 245, 255, 0.1)',
                  color: 'primary.main',
                  fontFamily: "'Fira Code', monospace",
                  fontSize: '0.75rem',
                  fontWeight: 500,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ExperienceCard;
